/* TODO: t() */
import React from 'react';
import Thumbnail from '../../Preview/Thumbnail';
import ControlledFormView from './FileUploadElement/ControlledFormView';
import FormElementBase from '../FormElementBase';
import FieldEditor from './FileUploadElement/FileUploadFieldEditorView';
import FormView from './FileUploadElement/FileUploadElementFormView';
import { Icon } from '../../uiold';
import { Text } from '../../../core-ui';

import IndexedList from '../../../support/shared/IndexedList';
import { FileDesc } from '../../../types/shared/FileDesc';
import { FormFieldDefinition } from '../../../types/shared/FormFieldDefinition';
import { Market } from '../../../types/shared/Market';
import { Field } from '../../../types/shared/Vendor';

type ReadOnlyViewProps = {
  isAdmin: boolean;
  value: FileDesc | null | undefined;
  onFileClick: (file: FileDesc, event: Event) => void;
  isLoading: boolean;
  markets: IndexedList<Market>;
  fields: IndexedList<Field>;
};

type FormViewProps = {
  onChange?: (id: string, file: FileDesc | null) => void;
};

type EditViewProps = {
  value: FileDesc | null;
  onChange: (id: string, file: FileDesc | null) => void;
  onValidityChange?: (
    id: string,
    validationError: string | null | undefined,
  ) => void;
};

class FileUploadElement extends FormElementBase {
  static getType() {
    return 'FileUploadElement';
  }

  static getDescription() {
    return 'Image/File Upload';
  }

  static getAttributes() {
    return {
      name: 'File',
      label: 'File Upload',
      image_only: false,
      hidden: false,
      is_required: false,
      is_public: false,
      includeExpiry: false,
      field_validation: null,
    };
  }

  static getIconName() {
    return 'addAttachment';
  }

  static getIcon() {
    return <Icon name="addAttachment" size="M" />;
  }

  renderFieldEditor() {
    return <FieldEditor key={this.id} ref="field-editor" parent={this} />;
  }

  renderFieldView() {
    return (
      <FormView
        key={this.id}
        ref={this.id}
        definition={this.definition as FormFieldDefinition}
        readOnly={true}
      />
    );
  }

  renderFormView(props?: FormViewProps) {
    props = props || {};
    return (
      <FormView
        key={this.id}
        ref={this.id}
        definition={this.definition as FormFieldDefinition}
        {...props}
      />
    );
  }

  renderReadOnlyView(props: ReadOnlyViewProps) {
    let { isAdmin, value: file, onFileClick } = props;
    if (file == null) {
      return isAdmin ? (
        <span className="empty-state">(No file specified)</span>
      ) : null;
    } else {
      return (
        <>
          <Thumbnail
            width={180}
            height={135}
            onPreview={onFileClick}
            file={file}
          />
          {file.expiryValue && (
            <Text>
              {t('Expiry: {expiryValue}', { expiryValue: file.expiryValue })}
            </Text>
          )}
        </>
      );
    }
  }

  renderEditView(props: EditViewProps) {
    let { value, onChange, onValidityChange } = props;
    return (
      <div className="form-field">
        <ControlledFormView
          key={this.id}
          ref={this.id}
          definition={this.definition as FormFieldDefinition}
          selectedFile={value}
          onChange={(file) => {
            onChange(this.id, file);
          }}
          onValidityChange={onValidityChange}
        />
      </div>
    );
  }
}

export default FileUploadElement;
